import React from 'react'
import Box from '@mui/material/Box'
import thankYouImage from '../assets/images/thank-you.png'

const ThankYou = () => {
  return (
    <Box
      component='img'
      src={thankYouImage}
      alt='Thank You'
      sx={{
        px: 2,
        width: '100%',
        maxHeight: '70vh',
        objectFit: 'contain',
        mt: 10,
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      }}
    />

  )
}

export default ThankYou
